/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';

export interface DeleteFixedWingLine$Params {
  id: number;
}

export function deleteFixedWingLine(http: HttpClient, rootUrl: string, params: DeleteFixedWingLine$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteFixedWingLine.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse>;
    })
  );
}

deleteFixedWingLine.PATH = '/api/scheduler/daily-line-schedule/fixed-wing/lines/{id}';
